const initialState = {
  values: {
    password_expired: false,
    is_admin: false,
    is_agency_admin: false,
    is_active: true,
    is_staff: false,
    can_quote: false,
    can_enroll: false,
    can_view_users: false,
    can_edit_users: false,
    can_add_users: false,
    can_view_reports: false,
    can_batch_upload: false,
    can_view_shopper_data: false,
    can_edit_translations: false,
    can_manage_agency: false,
    can_manage_campaigns: false,
    can_use_telephony: false,
    can_view_calls: false,
    can_manage_agents_ap: false,
    can_manage_campaigns_ap: false,
    can_manage_formulary: false,
    can_manage_logos: false,
    can_manage_config_data: false,
    can_manage_site_configs: false,
    can_create_new_sites: false,
    can_manage_rts: false,
    is_test_user: false,
  },
  errors: {},
  validations: {
    first_name: false,
    middle_name: true,
    last_name: false,
    email: false,
    mobile_phone: true,
    npn: false,
  },
  saving: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_USER_SAVE':
      return { ...state, saving: true, errors: {} };
    case 'ADD_USER_CLEAR_SAVE':
      return { ...state, saving: false };
    case 'CLEAR_ERRORS':
      return { ...state, errors: {} };
    case 'ADD_USER_ERROR': {
      const errors = { ...state.errors, [action.id]: action.message || true };
      return { ...state, errors };
    }
    case 'EDIT_ADD_USER': {
      const values = { ...state.values, [action.id]: action.value };
      const validations = { ...state.validations, [action.id]: action.valid };
      return { ...state, values, validations };
    }
    case 'EDIT_ADD_USER_VALIDATION':
      return {
        ...state,
        validations: {
          ...state.validations,
          ...action.payload,
        },
      };
    case 'ADD_USER_PERMISSIONS': {
      const values = { ...state.values, [action.id]: action.value };
      return { ...state, values };
    }
    case 'CLEAR_ADD_USER':
      return { ...initialState };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
